'use client';

import React from 'react';

import locationStore from 'stores/LocationStore';
/** components */
import List from '@sympla/sympla-components/List';
import ListItem from '@sympla/sympla-components/ListItem';
/** icons */
import { IconAgenda } from '@sympla/sympla-components/SocialIcons';
import { createLinkToRedirect } from 'utils/createLinkToRedirect';
import { listPredefinedDates } from 'constants/listPredefinedDates';

import locales from './_locales/StaticDateFilter.json';

/* Style -------------------------------------------------------- */
import * as styles from './StaticDateFilter.css';

type StaticDateFilter = {
  lang?: 'pt' | 'es' | 'en';
  categoryName: string;
  categoryValue?: string;
};

export function StaticDateFilter({ lang = 'pt', categoryName, categoryValue }: StaticDateFilter) {
  const renderSubtitle = (categoryName: string) => {
    const categoryText = categoryName ? ` ${locales[lang].PREPOSITION_OF} ${categoryName}` : '';
    const cityText = locationStore?.selectedLocation?.city ? `${locales[lang].PREPOSITION_IN} ${locationStore?.selectedLocation?.city}` : '';
    return `${categoryText} ${cityText}`;
  };

  return (
    <div className={styles.StaticDateFilterContainer}>
      <h2 className={styles.StaticDateFilterTitle}>
        {categoryName ? locales[lang].OTHERS_SUGGESTIONS_CATEGORY : locales[lang].OTHERS_SUGGESTIONS_CITY}
      </h2>
      <div className={styles.ListContent}>
        <List
          columns={{
            xs: 1,
            sm: 2,
            md: 3,
          }}
        >
          {listPredefinedDates.map((option) => (
            <ListItem
              key={option.label}
              href={createLinkToRedirect({
                item: {
                  date: option?.dateId,
                  urn: '',
                  category: categoryValue,
                },
                param: `?d=${option?.param}`,
                routeType: 'search-bar-default-filter',
                userLocation: locationStore?.selectedLocation,
              })}
            >
              <h3 className={styles.FilterOption}>
                <IconAgenda width={32} height={32} className={styles.IconOption} />
                <div className={styles.FilterOptionInfo}>
                  <div className={styles.FilterOptionTitle}>{`${locales[lang].EVENTS} ${option.label}`}</div>
                  <div className={styles.FilterOptionSubtitle}>{renderSubtitle(categoryName)}</div>
                </div>
              </h3>
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
}

export default StaticDateFilter;
